import { useState, useEffect } from 'react';

const StickyHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('accueil');

  const navItems = [
    { name: 'Accueil', href: 'accueil' },
    { name: 'À propos', href: 'apropos' },
    { name: 'Prestations', href: 'services' },
    { name: 'Formules', href: 'formules' },
    { name: 'Galerie', href: 'galerie' },
    { name: 'Avis', href: 'avis' },
    { name: 'Distinctions', href: 'recompenses' },
    { name: 'Contact', href: 'contact' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);

      // Détection de la section active
      const sections = navItems.map(item => item.href);
      const scrollPosition = window.scrollY + 200;

      for (let i = sections.length - 1; i >= 0; i--) {
        const element = document.getElementById(sections[i]);
        if (element && element.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-black/95 backdrop-blur-md shadow-2xl border-b border-white/10' 
          : 'bg-transparent'
      }`}
    >
      <nav className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div 
            onClick={() => scrollToSection('accueil')}
            className="cursor-pointer"
          >
            <h1 className="text-2xl font-bold text-white" style={{ fontFamily: 'Alice, serif' }}>
              L'Art des Mets
            </h1>
          </div>

          {/* Navigation Desktop */}
          <div className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.href}
                onClick={() => scrollToSection(item.href)}
                className={`text-sm transition-all duration-300 whitespace-nowrap cursor-pointer relative py-2 px-3 rounded-full ${
                  activeSection === item.href
                    ? 'text-white bg-white/20 backdrop-blur-sm'
                    : 'text-gray-300 hover:text-white hover:bg-white/10'
                }`}
              >
                {item.name}
                {activeSection === item.href && (
                  <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-white rounded-full"></div>
                )}
              </button>
            ))}
          </div>

          {/* Bouton CTA Desktop */}
          <div className="hidden lg:block">
            <button
              onClick={() => window.open('https://www.moulin-vert.com/', '_blank')}
              className="bg-gradient-to-r from-gray-600 to-gray-400 text-black px-6 py-2 rounded-full font-semibold text-sm hover:from-gray-500 hover:to-gray-300 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Voici notre salle de réception
            </button>
          </div>

          {/* Menu Mobile */}
          <div className="lg:hidden">
            <MobileMenu navItems={navItems} scrollToSection={scrollToSection} activeSection={activeSection} />
          </div>
        </div>
      </nav>
    </header>
  );
};

const MobileMenu = ({ navItems, scrollToSection, activeSection }: {
  navItems: Array<{ name: string; href: string }>;
  scrollToSection: (sectionId: string) => void;
  activeSection: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleItemClick = (href: string) => {
    scrollToSection(href);
    setIsOpen(false);
  };

  return (
    <>
      {/* Bouton hamburger */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="text-white p-2 rounded-lg hover:bg-white/10 transition-colors duration-300"
      >
        <div className="w-6 h-6 flex flex-col justify-center items-center">
          <span className={`block w-5 h-0.5 bg-white transition-all duration-300 ${isOpen ? 'rotate-45 translate-y-1' : ''}`}></span>
          <span className={`block w-5 h-0.5 bg-white mt-1 transition-all duration-300 ${isOpen ? 'opacity-0' : ''}`}></span>
          <span className={`block w-5 h-0.5 bg-white mt-1 transition-all duration-300 ${isOpen ? '-rotate-45 -translate-y-1' : ''}`}></span>
        </div>
      </button>

      {/* Menu mobile overlay */}
      {isOpen && (
        <>
          <div 
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40"
            onClick={() => setIsOpen(false)}
          ></div>
          <div className="absolute top-full left-0 right-0 bg-black/95 backdrop-blur-md border-b border-white/10 z-50">
            <div className="container mx-auto px-6 py-4">
              <div className="flex flex-col space-y-3">
                {navItems.map((item) => (
                  <button
                    key={item.href}
                    onClick={() => handleItemClick(item.href)}
                    className={`text-left py-3 px-4 rounded-lg transition-all duration-300 ${
                      activeSection === item.href
                        ? 'text-white bg-white/20'
                        : 'text-gray-300 hover:text-white hover:bg-white/10'
                    }`}
                  >
                    {item.name}
                  </button>
                ))}
                <button
                  onClick={() => handleItemClick('contact')}
                  className="bg-gradient-to-r from-gray-600 to-gray-400 text-black px-6 py-3 rounded-lg font-semibold text-center hover:from-gray-500 hover:to-gray-300 transition-all duration-300 mt-4"
                >
                  Demander un devis
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default StickyHeader;